import { Entry } from '../Entry'

export function Entry20240417() {
  return (
    <Entry title="Apr 17 2024 - v3.6.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15676/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
